import { useCallback } from "react"
import { DashBoardCondition } from "features/dashBoard/types"
import { useBarGraphOption } from "./options"
import { useGraphZoom } from "../../../components/zoom"

type useBarGraphEventsProps<T> = {
	graphOption: ReturnType<typeof useBarGraphOption<T>>
	graphZoom: ReturnType<typeof useGraphZoom>
	onChangeCondition: (
    axisKey?: string,
    changed?: DashBoardCondition,
    toggle?: boolean
  ) => void
}
export const useBarGraphEvents = <T,>({
	graphOption: {
		axisDef
	},
	graphZoom: {
		onDataZoom
	},
	onChangeCondition
}: useBarGraphEventsProps<T>) => {
	const onClickGraph = useCallback(
		(params?: {
			event?: { event?: { ctrlKey?: boolean } }
			data: { key: string, name: string }
		}) => {
			const data = params?.data
			if (!data) return
			onChangeCondition(
				axisDef?.key,
				{ code: [data.key], label: data.name },
				params?.event?.event?.ctrlKey ? true : false
			)
		},
		[axisDef, onChangeCondition]
	)
	return {
		click: onClickGraph,
		dataZoom: onDataZoom
	}
}